import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import Icon from './Icon';

const StyledIcon = styled(Icon)`
  fill: none;
`;

const EducatorAvatar = (props) => {
  const { color, ...rest } = props;
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <StyledIcon viewBox="0 0 20 20" {...rest}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.458 6.25a3.542 3.542 0 1 1 7.084 0 3.542 3.542 0 0 1-7.084 0zM10 3.958a2.292 2.292 0 1 0 0 4.584 2.292 2.292 0 0 0 0-4.583zM6.667 12.292c-1.036 0-1.875.84-1.875 1.875v.99c0 .015.01.028.025.03 3.433.56 6.933.56 10.365 0a.03.03 0 0 0 .026-.03v-.99c0-1.036-.84-1.875-1.875-1.875h-.284a.208.208 0 0 0-.064.01l-.722.236a7.29 7.29 0 0 1-4.526 0l-.722-.236a.209.209 0 0 0-.064-.01h-.284zm-3.125 1.875c0-1.726 1.399-3.125 3.125-3.125h.284c.153 0 .306.024.452.072l.722.235a6.042 6.042 0 0 0 3.75 0l.722-.235c.146-.048.299-.072.452-.072h.284c1.726 0 3.125 1.399 3.125 3.125v.99a1.28 1.28 0 0 1-1.074 1.264 33.416 33.416 0 0 1-10.768 0 1.28 1.28 0 0 1-1.074-1.264v-.99z"
        fill={color}
      />
    </StyledIcon>
  );
};

EducatorAvatar.propTypes = {
  color: PropTypes.string
};

EducatorAvatar.defaultProps = {
  color: 'var(--color-text-primary)'
};

export default EducatorAvatar;
